"use strict";

var _interopRequireWildcard3 = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard.js"));
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
var _AffiliationGroup = _interopRequireDefault(require("./components/AffiliationGroup"));
var strings = _interopRequireWildcard3(require("@/utils/strings"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    AffiliationGroup: _AffiliationGroup.default
  },
  data: function data() {
    return {
      group_id: "",
      company: [],
      textOrganization: "",
      fileList: [],
      form: {
        companyName: "",
        representative: "",
        industry: "",
        tel: ""
      },
      companies: [],
      drawer: false,
      title: "",
      downloadLoading: false
    };
  },
  computed: {
    coms: function coms() {
      return this.$store.getters.members;
    },
    currentPage: function currentPage() {
      return this.$store.getters.page_top;
    },
    maxPage: function maxPage() {
      return this.$store.getters.page_last;
    },
    searching: {
      get: function get() {
        return this.$store.getters.companieSearching;
      },
      set: function set(val) {
        this.$store.dispatch("company/setSearching", val);
      }
    },
    industry_major: function industry_major() {
      return this.$store.getters.industryMajorOptions;
    },
    industry_middle: function industry_middle() {
      return this.$store.getters.industryMiddleOptions;
    },
    selectedMiddleLabel: function selectedMiddleLabel() {
      var _this = this;
      if (!this.industry_middle) return '';
      var item = this.industry_middle.find(function (x) {
        return String(x.no) === String(_this.form.industry);
      });
      return item ? "".concat(item.no, "\uFF1A").concat(item.title) : "";
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var hasSearchCondition, titleString;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            hasSearchCondition = !!this.$store.getters.companieSearching || !!this.$store.state.company.majorCode || !!this.$store.state.company.middleCode || this.$store.state.company.listAllIdsFromLastItem.length > 0;
            if (hasSearchCondition) {
              _context.n = 3;
              break;
            }
            this.searching = "";
            this.$store.commit("company/pathToListItem", []);
            this.$store.commit("company/getDataSearchAffiliation", []);
            _context.n = 1;
            return this.$store.dispatch("company/clear");
          case 1:
            _context.n = 2;
            return this.$store.dispatch("company/setSearching", "");
          case 2:
            _context.n = 3;
            return this.$store.dispatch("company/setPageTop", 0);
          case 3:
            _context.n = 4;
            return this.$store.commit("company/setEnableTextAllSelect", true);
          case 4:
            _context.n = 5;
            return this.$store.dispatch("company/getSearchIndustryMajorList");
          case 5:
            // ここから表示復元
            this.group_id = this.$store.state.company.majorCode || "";
            if (!this.group_id) {
              _context.n = 6;
              break;
            }
            _context.n = 6;
            return this.$store.dispatch("company/getSearchIndustryMiddleList", {
              group_id: this.group_id
            });
          case 6:
            if (this.$store.state.company.middleCode) {
              this.form.industry = this.$store.state.company.middleCode;
            } else if (this.group_id) {
              this.form.industry = "00";
            } else {
              this.form.industry = "";
            }
            if (hasSearchCondition && this.$store.state.company.pathToListItem.length > 0) {
              titleString = [];
              this.$store.state.company.pathToListItem.forEach(function (item) {
                titleString.push(item.name);
              });
              this.title = titleString.join(" / ");
            } else {
              this.title = "";
            }
            _context.n = 7;
            return this.$store.dispatch("company/fetchMembers");
          case 7:
            this.textOrganization = strings.textChangeByZone().textBranchAreaByZone;
          case 8:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    swapComponent: function swapComponent(data) {
      this.drawer = !this.drawer;
      if (this.$store.state.company.listAllIdsFromLastItem.length > 0) {
        var titleString = [];
        this.$store.getters.pathToListItem.map(function (item) {
          return titleString.push(item.name);
        });
        this.title = titleString.join(" / ");
      } else {
        this.title = "";
      }
    },
    search: function () {
      var _search = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.$store.dispatch("company/setPageTop", 0);
            case 1:
              _context2.n = 2;
              return this.$store.dispatch("company/fetchMembers");
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function search() {
        return _search.apply(this, arguments);
      }
      return search;
    }(),
    changeIndustryMajor: function () {
      var _changeIndustryMajor = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.$store.dispatch("company/getSearchIndustryMiddleList", {
                group_id: this.$data.group_id
              });
            case 1:
              if (!(this.$data.group_id === 0)) {
                _context3.n = 3;
                break;
              }
              this.$data.form.industry = "00";
              _context3.n = 2;
              return this.$store.dispatch("company/setMiddleCode", null);
            case 2:
              _context3.n = 4;
              break;
            case 3:
              this.$data.form.industry = "00";
              _context3.n = 4;
              return this.$store.dispatch("company/setMiddleCode", null);
            case 4:
              if (!(this.$data.group_id === 0)) {
                _context3.n = 6;
                break;
              }
              _context3.n = 5;
              return this.$store.dispatch("company/setMajorCode", null);
            case 5:
              _context3.n = 7;
              break;
            case 6:
              _context3.n = 7;
              return this.$store.dispatch("company/setMajorCode", this.$data.group_id);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function changeIndustryMajor() {
        return _changeIndustryMajor.apply(this, arguments);
      }
      return changeIndustryMajor;
    }(),
    changeIndustryMiddle: function () {
      var _changeIndustryMiddle = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!(this.$data.form.industry == "00")) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return this.$store.dispatch("company/setMiddleCode", null);
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.n = 3;
              return this.$store.dispatch("company/setMiddleCode", this.$data.form.industry);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function changeIndustryMiddle() {
        return _changeIndustryMiddle.apply(this, arguments);
      }
      return changeIndustryMiddle;
    }(),
    addCompany: function addCompany() {
      this.$router.push({
        name: "CompanyCreate"
      });
    },
    importCsv: function importCsv() {
      this.$router.push({
        name: "CompanyCsvImport"
      });
    },
    goToDetail: function goToDetail(data) {
      this.$store.commit("company/setEnableTextAllSelect", false);
      this.$router.replace({
        name: "CompanyAdminEdit",
        params: {
          uid: data.uid
        }
      });
    },
    goToEventPerCo: function goToEventPerCo(data) {
      this.$router.replace({
        name: "PerCompany",
        params: {
          data: data
        }
      });
    },
    handleSelect: function handleSelect() {},
    goTopPage: function () {
      var _goTopPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.$store.dispatch("company/setPageTop", 0);
            case 1:
              _context5.n = 2;
              return this.$store.dispatch("company/fetchMembers");
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function goTopPage() {
        return _goTopPage.apply(this, arguments);
      }
      return goTopPage;
    }(),
    goPrePage: function () {
      var _goPrePage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var pre;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.$store.dispatch("company/getPageTop");
            case 1:
              pre = _context6.v;
              if (!(pre > 0)) {
                _context6.n = 3;
                break;
              }
              _context6.n = 2;
              return this.$store.dispatch("company/setPageTop", pre - 1);
            case 2:
              _context6.n = 3;
              return this.$store.dispatch("company/fetchMembers");
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function goPrePage() {
        return _goPrePage.apply(this, arguments);
      }
      return goPrePage;
    }(),
    goNextPage: function () {
      var _goNextPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7() {
        var next, last, _t;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.$store.dispatch("company/getPageTop");
            case 1:
              next = _context7.v;
              _t = Math;
              _context7.n = 2;
              return this.$store.dispatch("company/getPageLast");
            case 2:
              last = _t.floor.call(_t, _context7.v);
              if (!(last > next)) {
                _context7.n = 4;
                break;
              }
              _context7.n = 3;
              return this.$store.dispatch("company/setPageTop", next + 1);
            case 3:
              _context7.n = 4;
              return this.$store.dispatch("company/fetchMembers");
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function goNextPage() {
        return _goNextPage.apply(this, arguments);
      }
      return goNextPage;
    }(),
    goLastPage: function () {
      var _goLastPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var last, _t2;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _t2 = Math;
              _context8.n = 1;
              return this.$store.dispatch("company/getPageLast");
            case 1:
              last = _t2.floor.call(_t2, _context8.v);
              _context8.n = 2;
              return this.$store.dispatch("company/setPageTop", last);
            case 2:
              _context8.n = 3;
              return this.$store.dispatch("company/fetchMembers");
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function goLastPage() {
        return _goLastPage.apply(this, arguments);
      }
      return goLastPage;
    }(),
    handleOpen: function handleOpen(key, keyPath) {},
    handleClose: function handleClose(key, keyPath) {},
    onSubmit: function onSubmit() {},
    toggleDrawer: function toggleDrawer() {
      this.drawer = !this.drawer;
    },
    querySearch: function () {
      var _querySearch = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9(query) {
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _context9.n = 1;
              return this.$store.dispatch("company/setPageTop", 0);
            case 1:
              _context9.n = 2;
              return this.$store.dispatch("company/fetchMembers");
            case 2:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function querySearch(_x) {
        return _querySearch.apply(this, arguments);
      }
      return querySearch;
    }(),
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return "";
      return dateStr.replace(/-/g, "/");
    },
    cleanPhone: function cleanPhone(val) {
      if (!val) return "";
      // 電話番号がハイフンとスペースのみの場合は空文字を返す。
      return /^[-\s]+$/.test(val) ? "" : val;
    },
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0() {
        var _this2 = this;
        var list, _t3;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              this.downloadLoading = true;
              _context0.p = 1;
              _context0.n = 2;
              return this.$store.dispatch("company/fetchMembersForExport");
            case 2:
              list = _context0.v;
              Promise.resolve().then(function () {
                return (0, _interopRequireWildcard2.default)(require("@/vendor/Export2Excel"));
              }).then(function (excel) {
                var tHeader = ["所属_ID", "入会年", "会社名", "会社名_ふりがな", "会員名", "会員名_ふりがな", "役職名", "郵便番号", "会社所在地", "ビル名", "電話番号", "携帯電話", "FAX", "Email", "ホームページ", "業種コード", "事業内容", "設立年月日", "資本金", "社員数", "パート_アルバイト数", "会員ID", "生年月日"];
                var data = list.map(function (item) {
                  var company = item.company || {};
                  var affiliationIds = (item.user_affiliations || []).map(function (a) {
                    return a.affiliation_id;
                  }).join(",");
                  return [affiliationIds, _this2.formatDate(company.join_date), company.name || "", company.name_furigana || "", item.full_name || "", item.full_name_furigana || "", item.position || "", company.postcode || "", company.address_1 || "", company.address_2 || "", _this2.cleanPhone(company.phone_number), _this2.cleanPhone(company.mobile_phone), _this2.cleanPhone(company.fax), company.email || "", company.website || "", company.industry || "", company.business_descriptions || "", _this2.formatDate(company.established), company.capital_stock || "", company.employees || "", company.employees_part_time || "", item.id || "", _this2.formatDate(item.birthday)];
                });
                excel.export_json_to_excel({
                  header: tHeader,
                  data: data,
                  filename: "会員一覧",
                  autoWidth: true,
                  bookType: "xlsx",
                  sheetName: "members",
                  stringColumns: [0]
                });
                _this2.downloadLoading = false;
              });
              _context0.n = 4;
              break;
            case 3:
              _context0.p = 3;
              _t3 = _context0.v;
              this.downloadLoading = false;
              this.$message.error("エクスポートに失敗しました");
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 3]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }()
  }
};